	window.lhnJsSdkInit = function () {
		lhnJsSdk.setup = {
			application_id: "2bfa7e0f-6f15-48e4-9848-3047f878d4b8",
			application_secret: "c6ec7b80d825434090cdb009cc3d52c44122d9ae07064784b9"
		};
		lhnJsSdk.controls = [{
			type: "hoc",
			id: "32dfbd28-1f5d-4838-995b-1c803e39bfcb"
		}];
		lhnJsSdk.options = {
	  		custom1: "Customer: {{ customer.id}}, {{ customer.name }}, {{ customer.total_spent }}",
	  		custom2: "Cart: {{ cart.item_count }} items ( ${{ cart.total_price }} ) ",
	  		custom3: "Last order date: {{ customer.last_order.created_at }}"
		};
	};

	(function (d, s) {
		var newjs, lhnjs = d.getElementsByTagName(s)[0];
		newjs = d.createElement(s);
		newjs.src = "https://developer.livehelpnow.net/js/sdk/lhn-jssdk-current.min.js";
		lhnjs.parentNode.insertBefore(newjs, lhnjs);
	}(document, "script"));
